<div [ngClass]="{'with-footer-alternative': utilService.isMobile}">
  <app-loader [loading]="isLoading" [overlay]="true"></app-loader>
  <ng-container *ngIf="user">
    <div class="bottom-spacer-x2">
      <app-users-view-form
        [user]="user"
        [isView]="false"
        [isCreate]="false"
        [isMyProfile]="true"
        (update)="update()"
      ></app-users-view-form>
    </div>
    <div class="flex space-between bottom-spacer">
      <div class="heading-3 bold">{{ 'general.api_users_form_view_legal_persons_title' | translate }}</div>
    </div>
    <app-users-view-legal-list
      [user]="user"
      [isView]="false"
      [isMyProfile]="true"
    ></app-users-view-legal-list>
  </ng-container>
</div>
